import { Box, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, Radio, Typography, styled } from '@mui/material';

import styles from "../devoteeService.module.scss"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useEffect, useState } from 'react';
import { ValidationError, object, string } from 'yup';
import { isNil } from 'lodash';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { CommonButton, CommonOutlinedButton, CustomCalendarTodayOutlinedIcon, CustomDatePicker, CustomDeleteIcon, CustomInputLabel, CustomMenuItem, CustomRequiredInputLabel, CustomSelect, CustomTextFeild, StyledDateContainer } from '../../common/StyledComponents/StyledFields';
import { apiRequest, catchErrorMessageHandler, getDevoteeId } from '../../../infrastructure/backendService';
import tablestyles from '../../devoteeService/devoteeService.module.scss';
import deleteIcon from '../../../assets/svg/delete_outline.svg';
import commonStyles from '../../../App.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import SuccessPopup from '../../devotee/donation/successPopup';
import LOCALE from '../../../config/en-us.json';
import constants from '../../../config/constants.json';
import toast, { Toaster } from 'react-hot-toast';
import ErrorPopup from '../../common/ErrorPopup';
import apiPath from '../../../config/apiPaths.json';
import { ClipLoader } from 'react-spinners';
interface ErrorMessageTypes {
    categorie: string;
}

interface CategoriesType {
    id: string | number | readonly string[] | undefined;
    name: string;

}
interface rolesId {
    defaultCategory: boolean;
    categoryId: any;
    id: string;
}
interface categoriesProps {
    onBackClick?: () => void;
}
const CustomRadioButton = styled(Radio)`
  & svg {
    color: #F05802;
    height: 16px;
    width:16px;
  }
`;

const Categories = (props: categoriesProps) => {
    const [categoryMapping, setCategoryMapping] = useState<{ [key: number]: string }>({});
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectData, setSelectData] = useState<any>([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [formData, setFormData] = useState({
        categorie: "",
    })
    const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
        categorie: "",
    })
    const formFields = {
        categorie: ""
    }
    const [categoriesList, setCategoriesList] = useState<CategoriesType[]>([]);
    const [roles, setRolesList] = useState<rolesId[]>([]);
    const [selectedSpecialId, setSelectedActivityId] = useState<any | null | undefined>(null);
    const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
    const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
    const [disableButton, setButtonDisable] = useState(true);
    const validationSchema = object().shape({
        categorie: string().required('Categorie is required'),
    })

    useEffect(() => {
        apiRequest({
            method: 'GET',
            endpoint: apiPath.categoriesListAll,
            includeToken: true,
            params: {
                size: 500,
            },
        })
            .then((res) => {
                const categories = res.data.content;
                setCategoriesList(categories);

                // Create a mapping of category IDs to names
                const mapping: { [key: number]: string } = {};
                categories.forEach((category: { id: any | number; name: string; }) => {
                    mapping[category.id] = category.name;
                });
                setCategoryMapping(mapping);

                console.log(categories);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const fetchTableData = () => {
        apiRequest({
            method: 'GET',
            endpoint: apiPath.categorieslist,
            includeToken: true,
            params: {
                username: getDevoteeId()?.userId || "",
            },
        })
            .then((res) => {
                setRolesList(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        fetchTableData();
    }, [])
    const handleFieldChange = (field: string, value: any) => {
        setFormData({
            ...formData,
            [field]: value,
        });
    };
    useEffect(() => {
        // Find the category with defaultCategory set to true
        const defaultCategory = roles.find(role => role.defaultCategory === true);
        if (defaultCategory) {
            setSelectedCategoryId(defaultCategory?.categoryId);
        }
    }, [roles]);
    const handleRadioChange = (categoryId: number) => {
        setSubmitLoading(false);
        setButtonDisable(false);
        setSelectedCategoryId(categoryId);
    };

    const handleSave = async (): Promise<void> => {
        const errors: ErrorMessageTypes = { ...formFields };
        try {
            // Validate the form data against the validation schema
            await validationSchema.validate(formData, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessage(errors);
            // Call your API or perform other actions here
            saveApiCall();
            //    setFormData(formFields);
        } catch (error: any) {
            // Handle validation errors
            if (error instanceof ValidationError) {
                error.inner.forEach((e: any) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypes] = e.message;
                    }
                });
            }
            setErrorMessage(errors);
        }
    };

    const saveApiCall = () => {
        setSubmitLoading(true);
        const reqBody = {
            username: getDevoteeId()?.userId,
            categoryId: formData?.categorie

        };
        apiRequest({
            method: 'POST',
            endpoint: apiPath.addedcategories,
            includeToken: true,
            body: JSON.stringify(reqBody),
            params: {
                scm: false
            }
        })
            .then((res) => {
                const successMessage = LOCALE.CATEGORIES_ADDED;
                toast.custom(
                    <SuccessPopup
                        headerMessage="Categories"
                        showMessage={successMessage}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                    />,
                );
                setFormData(formData);
                fetchTableData();
                setSubmitLoading(false)
            })
            .catch((err) => {
                toast.custom(
                    <ErrorPopup
                        showMessage={catchErrorMessageHandler(err)}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                    />,
                    {
                        duration: constants.TOAST_POPUP_DURATION,
                    },
                );
                setSubmitLoading(false);
            });
    };

    const updateCategoriesApiCall = () => {
        setUpdateLoading(true);
        const selectedRole = roles.find(role => Number(role.categoryId) === selectedCategoryId);
        if (!selectedRole) {
            console.error("No matching role found for the selected category ID.");
            return;
        }
        const reqBody = {
            id: selectedRole?.id,
            username: getDevoteeId()?.userId,
            categoryId: selectedCategoryId,
            defaultCategory: true
        };
        apiRequest({
            method: 'PUT',
            endpoint: apiPath.UpdateCategories,
            body: JSON.stringify(reqBody),
            includeToken: true,
            params: {
                scm: false
            }
        })
            .then((res) => {
                const successMessage = LOCALE.UPADTED_CATEGORIE;
                toast.custom(
                    <SuccessPopup
                        headerMessage="Details Update"
                        showMessage={successMessage}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                    />,
                    {
                        duration: constants.TOAST_POPUP_DURATION,
                    },
                );
                setUpdateLoading(false);
            })
            .catch((err) => {
                toast.custom(
                    <ErrorPopup
                        showMessage={catchErrorMessageHandler(err)}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                    />,
                    {
                        duration: constants.TOAST_POPUP_DURATION,
                    },
                );
                setUpdateLoading(false);
            });
    };

    const handleDeleteCategories = () => {
        deleteCategoriesApiCall();
    };

    const deleteCategoriesApiCall = () => {
        apiRequest({
            method: 'DELETE',
            endpoint: "/devotee-management/deleteUserCategories",
            includeToken: true,
            params: {
                ids: selectedSpecialId
            }
        })
            .then((res) => {
                console.log(res.data)
                if (selectedCategoryId) {
                    setButtonDisable(true);
                } else {
                    setButtonDisable(false);
                }
                fetchTableData();
            })
            .catch((err) => {
                toast.custom(
                    <ErrorPopup
                        showMessage={catchErrorMessageHandler(err)}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                    />,
                    {
                        duration: constants.TOAST_POPUP_DURATION,
                    },
                );
            });
    };
    const handleClose = () => {
        setIsOpen(false);
        setIsOpenDialog(false);
        setSelectedId(null);
        setSelectedActivityId(null);
    };
    const handleAgree = () => {
        if (selectedSpecialId !== null && roles && roles) {
            // Find the index of the item with the selected ID in the roles array
            const indexToRemove = roles.findIndex(
                (item: rolesId) => item.id === selectedSpecialId,
            );
            handleDeleteCategories();
          
        }
        // Close the dialog
        handleClose();
    };

    const dialogPopup = () => {
        return (
            <Dialog
                open={isOpenDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        height: 'calc(100% - 128px)',
                        width: 'calc(100% - 128px)',
                        margin: '64px',
                        maxWidth: '504px',
                        maxHeight: '180px',
                        overflowY: 'unset',
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                    },
                }}
            >
                <DialogTitle className={commonStyles.dialogTitle}>
                    {'Please Confirm'}

                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 24,
                            top: 12,
                            color: (theme: any) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon sx={{ color: 'white' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-slide-description"
                        className={commonStyles.dialogContext}
                    >
                        Are you sure want to remove the categories?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
                    <CommonButton onClick={handleAgree}>Yes</CommonButton>
                </DialogActions>
            </Dialog>
        );
    };
    const tableContainer = () => {
        return (
            <Box className={styles.tableContainer}>
                <div style={{ overflow: 'auto' }}>
                    <table className={tablestyles.tableContainer}>
                        <thead>
                            <tr className={tablestyles.headerTableRow}>
                                <th className={tablestyles.tableHorizontal}>Default</th>
                                <th className={tablestyles.tableHorizontal}>Category</th>
                                <th className={tablestyles.tableHorizontal}>Action</th>
                            </tr>
                        </thead>
                        <tbody className={tablestyles.tableBody} id="searchData">
                            <tr className={tablestyles.tableRow}>
                                {roles.length > 0 ? (
                                    <td
                                        className={tablestyles.tableDiagonal}
                                        style={{
                                            color: '#000',
                                            fontWeight: 400,
                                            textAlign: 'start',
                                        }}
                                    >
                                    </td>
                                ) :
                                    <td
                                        className={tablestyles.tableDiagonal}
                                        style={{
                                            color: '#000',
                                            fontWeight: 400,
                                            textAlign: 'start',
                                        }}
                                    >
                                    </td>
                                }

                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        color: '#000',
                                        fontWeight: 400,
                                        textAlign: 'start',
                                    }}
                                >
                                    Devotee
                                </td>
                                <td
                                    className={tablestyles.tableDiagonal}
                                    style={{
                                        color: '#000',
                                        fontWeight: 400,
                                        textAlign: 'start',
                                    }}
                                >
                                </td>
                            </tr>
                            {roles.map((row: any, index: number) => (
                                <tr key={row.id} className={tablestyles.tableRow}>

                                    <td
                                        className={tablestyles.tableDiagonal}
                                        style={{
                                            color: '#000',
                                            fontWeight: 400,
                                            textAlign: 'start',
                                        }}
                                    >
                                        <CustomRadioButton
                                            onChange={() => handleRadioChange(row.categoryId)}
                                            checked={row.categoryId === selectedCategoryId}
                                        />
                                    </td>
                                    <td
                                        className={tablestyles.tableDiagonal}
                                        style={{
                                            color: '#000',
                                            fontWeight: 400,
                                            textAlign: 'start',
                                        }}
                                    >
                                        {categoryMapping[row.categoryId]}
                                    </td>
                                    <td className={styles.tableDiagonal} style={{ cursor: "pointer" }}>
                                        <img src={deleteIcon} onClick={() => openConfirmPopUp1(row?.id)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Box>
        );
    };

    const CategoryDropdown = (): React.ReactElement => {
        return (
            <FormControl className={styles.dropDowns}>
                <CustomSelect
                    IconComponent={KeyboardArrowDownIcon}
                    defaultValue=""
                    id="grouped-select"
                    placeholder='Select categorie'
                    value={formData.categorie}
                    onChange={(e) => {
                        handleFieldChange('categorie', e.target.value);
                        setErrorMessage({ ...errorMessage, categorie: "" })
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                border: '1px solid #F05802',
                                '& ul': {
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    overflowY: 'auto',
                                    minHeight: 'auto',
                                    maxHeight: '300px',
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#F3C539',
                                        borderRadius: '6px',
                                    },
                                },
                            },
                        },
                    }}
                    className={errorMessage.categorie ? styles.errorTextField : styles.textField}>
                    {categoriesList.map((item, index) => (
                        <CustomMenuItem key={index} value={item.id}>
                            {item.name}
                        </CustomMenuItem>
                    ))}
                </CustomSelect>
                {errorMessage.categorie ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.categorie}</Typography> : ''}
            </FormControl>
        )
    }
 
    const openConfirmPopUp1 = (id: number | undefined | null) => {
        setSelectedActivityId(id);
        setIsOpenDialog(true);
    };
    return (
        <div>
            <div style={{ display: "flex" }}>
                <Toaster />
                <div className={styles.CategoriesContainer}>
                    {dialogPopup()}
                    <Typography component="div" className={styles.typoGraphyHeading}>
                        Devotee Service
                    </Typography>
                    <div className={styles.formContainer}>
                        {!isNil(props.onBackClick) && (
                            <CommonOutlinedButton
                                onClick={props.onBackClick}
                                sx={{ marginTop: "10px", marginRight: "10px", float: "right" }}
                            >
                                Back to Search Devotee
                            </CommonOutlinedButton>
                        )}
                        <Typography component="div" className={styles.typoGraphy}>
                            Categories
                        </Typography>
                        <Typography className={styles.typography}>
                            {getDevoteeId()?.fullName}<br />
                            {getDevoteeId()?.address}<br />
                            {getDevoteeId()?.city}, {getDevoteeId()?.state} - {getDevoteeId()?.zipcode} {getDevoteeId()?.country} <br />
                            <strong>Home Phone:</strong>{getDevoteeId()?.homephone} {" "}<strong>Work Phone:</strong>{getDevoteeId()?.workphone}<br />
                        </Typography>
                        <Card className={styles.cardContainer}>
                            <div style={{ padding: "0px 24px 24px 24px" }}>
                                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                    <Grid xs={12} sm={4} item>
                                        {CustomRequiredInputLabel("Date Of Birth", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            disabled
                                            className={styles.textField}
                                            value={getDevoteeId()?.dateOfBirth}
                                        />

                                    </Grid>
                                    <Grid xs={12} sm={4} item>
                                        {CustomRequiredInputLabel("Preffered Language", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            disabled
                                            className={styles.textField}
                                            value={getDevoteeId()?.preferedLangu}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={4} item>
                                        <CustomInputLabel>Nakshatram</CustomInputLabel>
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            disabled
                                            className={styles.textField}
                                            placeholder="Enter Nakshatram"
                                            value={getDevoteeId()?.nakshatram}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                   
                                    <Grid xs={12} sm={4} item>
                                        <CustomInputLabel>Gothram</CustomInputLabel>
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            disabled
                                            className={styles.textField}
                                            placeholder="Enter Gothram"
                                            value={getDevoteeId()?.gothram}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={4} item>
                                        {CustomRequiredInputLabel("Access", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            className={styles.textField}
                                            placeholder="Enter Access"
                                            value={getDevoteeId()?.access}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={4} item>
                                        {CustomRequiredInputLabel("Date of Registration", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            className={styles.textField}
                                            placeholder="Enter date"
                                            value={getDevoteeId()?.dateofregistration}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                    <Grid xs={12} sm={4} item>
                                        {CustomRequiredInputLabel("Update Date", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            className={styles.textField}
                                            value={getDevoteeId()?.updateDate}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={4} item>
                                        {CustomRequiredInputLabel("Category", true)}
                                        {CategoryDropdown()}
                                    </Grid>
                                </Grid>
                                <CommonButton sx={{ marginTop: "10px" }} onClick={handleSave}>
                                    {submitLoading ? (
                                        <>
                                            <ClipLoader size={20} color="#fff" />
                                            <span style={{ marginLeft: '8px' }}>Add</span>
                                        </>
                                    ) : (
                                        'Add'
                                    )}
                                </CommonButton>
                            </div>

                        </Card>
                    </div>
                    {tableContainer()}
                    <div style={{ marginTop: "20px" }}>
                        {roles ?
                            <CommonButton onClick={updateCategoriesApiCall} disabled={disableButton}>
                                {updateLoading ? (
                                    <>
                                        <ClipLoader size={20} color="#fff" />
                                        <span style={{ marginLeft: '8px' }}>Update</span>
                                    </>
                                ) : (
                                    'Update'
                                )}

                            </CommonButton>
                            : ""}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Categories;
